import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React, { useState } from 'react'
import { toast } from 'react-hot-toast'
import MathUtils from 'mvppoker-portal-common/utils/MathUtils'
import { UserApi } from 'mvppoker-portal-common/api'
import { createMVPModal } from '../Modal'
import WalletAddressModal from '../WalletAddressModal/WalletAddressModal'
import { WalletWithdrawFundsModalView } from './WalletWithdrawFundsModalView'
import { useActiveUser } from '../../../state/hooks/ActiveUserHooks'
import { useApi } from '../../../utils/useApi'

class WalletAddFundsModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('wallet-withdraw-funds-modal', () =>
		{
			const modal = useModal()
			const { wallet } = useActiveUser()!
			const api = useApi(UserApi)

			const [isLoading, setLoading] = useState(false)
		
			const clickCancel = () => { modal.hide() }

			const clickSubmit = (amount: string) => {
				const walletAddress = wallet.address?.trim()
				if (!walletAddress || walletAddress.length === 0 || walletAddress === '-') {
					toast.error('You need to add a Wallet Address first')
					modal.hide()
					WalletAddressModal.Show()
					modal.remove()
					return
				}
				if (MathUtils.IsLessThanOrEqualTo(amount, '0')) {
					toast.error('Choose an amount greater than 0')
					return
				}
				if (MathUtils.IsGreaterThan(amount, wallet.amount)) {
					toast.error(`You cannot withdraw more than your current balance: ${wallet.amount}`)
					return
				}
		
				setLoading(true)
		
				api
					.usersWalletRequestWithdrawal({ value: amount })
					.then(() => toast.success('Requested!'))
					.then(() => modal.hide())
					.catch((err) => {
						toast.error('An error occurred')
						modal.reject(err)
						setLoading(false)
					})
			}

			return <div> </div>
			// return <WalletWithdrawFundsModalView 
			// 	userWallet={wallet}
			// 	isLoading={isLoading}

			// 	clickSubmit={clickSubmit}
			// 	clickCancel={clickCancel}
			// />
		}))
	}
}

const modal = new WalletAddFundsModal()
export default modal